import React, { useRef, useState } from 'react';
import {
    NumberInput,
    List,
    Datagrid,
    TextField,
    EditButton,
    TextInput,
    Filter,
    DateField,
    ReferenceField,
    Pagination,
    NumberField,
    SimpleList,
    SelectInput,
    TopToolbar,
    FilterButton,
    ReferenceInput,
    AutocompleteInput,
    useRefresh,
    useDelete,
    useListContext,
    SimpleForm,
    Toolbar,
    ArrayField,
    SingleFieldList,
    FunctionField,
    BulkDeleteButton
} from 'react-admin';
import NfcIcon from '@mui/icons-material/Nfc';
import { request, formatCurrencyWithCode, formatCurrency, dateToLocalString, notifyConfirm, notifySuccess, notifyError } from "../../util";
import { translate } from "../../i18n/customI18nProvider";
import config from '../../config';
import Button from '@material-ui/core/Button';
import { Dialog, DialogTitle, useMediaQuery, Menu, Box, Typography, Chip } from '@material-ui/core';

import LinkIcon from '@mui/icons-material/Link';
import FilterListIcon from '@mui/icons-material/FilterList';
import ClientImportExcel from '../../components/client/ClientImportExcel';

export const ClientIcon = NfcIcon;
import { getRight } from '../../services/storage';
import { Stack } from '@mui/material';
import { getBalanceTransferFromWristband } from '../../services/wristband.service';
import ClientImportPacket from '../../components/client/ClientImportPacket';
import { ArrowDropDown, Delete, PostAdd } from '@mui/icons-material';
import ClientCancelPacket from '../../components/client/ClientCancelPacket';
import ClientImportManual from '../../components/client/ClientImportManual';
import ClientCheck from '../../components/client/ClientCheck';
import ResponsiveDatagrid from '../../components/reactAdmin/ResponsiveDatagrid';
import { deleteClient } from '../../services/client.service';
import { EventCash } from '../../services/event.service';
import { SWIPE_ANIMATIONS } from '../../components/table/SwipeableRow';

const ClientListFilters = [
    <TextInput key={"uid"} label={translate('custom.uid')} source="uid" variant='outlined' alwaysOn />,
    <TextInput key={"short_id"} label={translate('custom.short_id')} source="short_id" variant='outlined' alwaysOn />,
    <TextInput key={"old_uids"} label={translate('custom.old_uids')} source="old_uids" variant='outlined' />,
    <TextInput key={"import_id"} label={translate('custom.import_id')} source="import_id" variant='outlined' />,
    <TextInput key={"name"} label={translate('custom.name')} source="name" variant='outlined' />,
    <NumberInput key={"balance"} label={translate('custom.balance')} source="balance" step={0.01} onWheel={(e) => e.target.blur()} variant='outlined' />,
    <NumberInput key={"total_spent"} label={translate('custom.total_spent')} source="total_spent" step={0.01} onWheel={(e) => e.target.blur()} variant='outlined' />,
    <SelectInput
        key={"age"}
        label={translate('custom.age')}
        source="age"
        choices={[{ id: 0, name: translate('custom.age_reverse_map.LESS_16') }, { id: 16, name: translate('custom.age_reverse_map.LESS_18') }, { id: 18, name: translate('custom.age_reverse_map.MORE_18') }]}
        variant='outlined'
    />,
    <TextInput key={"ticket_id"} label={translate('custom.ticket_id')} source="ticket_id" variant='outlined' />,
    <TextInput key={"transaction_id"} label={translate('custom.transaction_id')} source="transaction_id" variant='outlined' />,
    <TextInput key={"card_number"} label={translate('custom.card_number')} source='["transactions.pan"]' variant='outlined' />,
    <TextInput key={"order_number"} label={translate('custom.order_number')} source="transactions.order_number" variant='outlined' />,
    <SelectInput
        key={"is_bracelet_used"}
        label={translate('custom.is_bracelet_used')}
        source="is_bracelet_used"
        choices={[{ id: true, name: translate('custom.yes') }, { id: false, name: translate('custom.no') }]}
        variant='outlined'
    />,
    <ReferenceInput
        key={"entrance_id"}
        variant='outlined'
        label={translate('custom.entrance')}
        reference="entrances"
        source="entrance_id"
        filterToQuery={searchText => ({ name: searchText, type: ['entrance', 'unpaid'] })}
    >
        <AutocompleteInput optionText="name" />
    </ReferenceInput>,
    <SelectInput
        key={"payment_types"}
        label={translate('custom.payment_types')}
        source="payment_types"
        choices={[
            { id: 'cash', name: translate('custom.cash') },
            { id: 'twint', name: translate('custom.twint') },
            { id: 'twint_direct', name: translate('custom.twint_direct') },
            { id: 'mypos', name: translate('custom.mypos') },
            { id: 'pos_phone', name: translate('custom.pos_phone') },
            { id: 'card', name: translate('custom.card') },
            { id: 'wristband', name: translate('custom.wristband') },
        ]}
        variant='outlined'
    />,
    <SelectInput
        key={"refund_types"}
        label={translate('custom.refund_types')}
        source="refund_types"
        choices={[
            { id: 'twint_refund', name: translate('custom.refund_types_description.twint_refund') },
            { id: 'mypos_refund', name: translate('custom.refund_types_description.mypos_refund') },
            { id: 'pos_phone_refund', name: translate('custom.refund_types_description.pos_phone_refund') },
            { id: 'card_refund', name: translate('custom.refund_types_description.card_refund') },
            { id: 'checkout', name: translate('custom.refund_types_description.checkout') },
            { id: 'form_refund', name: translate('custom.refund_types_description.form_refund') },
        ]}
        variant='outlined'
    />
];

const ClientListFilter = (props) => (
    <Filter {...props}>
        {(props.right >= config.permissions.SUPERADMIN.value) ? (
            <ReferenceInput variant='outlined' label={translate('custom.event')} reference="events" source="event_id" filterToQuery={searchText => ({ name: searchText })} alwaysOn >
                <AutocompleteInput optionText="name"/>
            </ReferenceInput>
        ) : null}
        {ClientListFilters.map((filter) => {
            if (filter.props?.source === 'total_spent') {
                return React.cloneElement(filter, {
                    alwaysOn: (props.is_hybrid && !props.has_ticket)
                });
            }
            if (filter.props?.source === 'ticket_id') {
                return React.cloneElement(filter, {
                    alwaysOn: props.has_ticket === true
                });
            }
            return filter;
        })}
    </Filter>
);

const CustomFilterToolbar = (props) => {
    return (
        <Toolbar {...props} style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <Button variant="contained" color="primary" onClick={props.handleSubmit}>
                {translate('custom.apply_filters')}
            </Button>
            <Button onClick={props.onClose} color="default" variant="outlined">
                {translate('custom.cancel')}
            </Button>
        </Toolbar>
    );
};

const MobileFilterModal = ({ open, onClose, right }) => {
    const { filterValues, setFilters, displayedFilters } = useListContext();

    const handleSubmit = (values) => {
        setFilters(values, displayedFilters);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>{translate('custom.filters')}</DialogTitle>
            
            <SimpleForm
                record={filterValues}
                save={handleSubmit}
                toolbar={<CustomFilterToolbar onClose={onClose} />}
            >
                {(right >= config.permissions.SUPERADMIN.value) ? (
                    <ReferenceInput variant='outlined' label={translate('custom.event')} reference="events" source="event_id" filterToQuery={searchText => ({ name: searchText })} fullWidth>
                        <AutocompleteInput optionText="name" resettable />
                    </ReferenceInput>
                ) : null}
                
                {ClientListFilters.map((filter) => 
                    React.cloneElement(filter, { fullWidth: true, alwaysOn: false })
                )}
            </SimpleForm>
        </Dialog>
    );
};

const ClientListActions = (props) => {
    const right = props.right;
    const isSmall = props.isSmall;
    const [anchorEl, setAnchorEl] = useState(null);
    const [isFilterModalOpen, setFilterModalOpen] = useState(false);
    const open = Boolean(anchorEl);

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    return (
        <TopToolbar>
            {!isSmall ? (
                <FilterButton filters={ClientListFilters} />
            ) : (
                <>
                    <Button 
                        color="primary" 
                        size="small" 
                        startIcon={<FilterListIcon />} 
                        onClick={() => setFilterModalOpen(true)}
                    >
                        {translate('custom.filter')} <Chip size="small" label={Object.keys(props.filterValues || {}).length} style={{marginLeft: '5px'}} />
                    </Button>
                    <MobileFilterModal 
                        open={isFilterModalOpen} 
                        onClose={() => setFilterModalOpen(false)} 
                        right={right} 
                    />
                </>
            )}

            {(right <= config.permissions.ADMIN.value) ? (
            <>
                <Button
                    color="primary"
                    size="small"
                    variant="contained"
                    startIcon={<PostAdd />}
                    endIcon={<ArrowDropDown />}
                    onClick={handleClick}
                    style={{marginLeft: '10px'}}
                >
                    Importer
                </Button>

                <Menu anchorEl={anchorEl} open={open} onClose={handleClose} keepMounted={true}>
                    <ClientImportExcel onClick={handleClose} />
                    <ClientImportPacket onClick={handleClose} />
                    <ClientImportManual onClick={handleClose} />
                    <ClientCheck onClick={handleClose} />
                    <ClientCancelPacket onClick={handleClose} />
                </Menu>
            </>
            ) : null}
        </TopToolbar>
    )
};

const CustomShowButton = (props) => {
    let link = `/client/${props.record.uid}`;
    if (props?.record?.archived) {
        link = `/event/${props.record.event_id}/client/${props.record.uid}`;
    }

    return (
        <Button
            color="primary"
            size="small"
            style={{marginRight: 10}}
            startIcon={<LinkIcon />}
            href={link}
            target="_blank"
        >
            {translate('custom.view')}
        </Button>
    )
}

const CustomBulkActionButtons = (props) => {
    const { selectedIds } = props;
    const { data } = useListContext();

    const uidMap = useRef({});

    if (data) {
        const list = Array.isArray(data) ? data : Object.values(data);
        list.forEach(item => {
            if (item?.uid) {
                const key = item.id || item._id;
                uidMap.current[key] = item.uid;
            }
        });
    }

    const selectedUids = selectedIds.map(id => uidMap.current[id] || data?.[id]?.uid || id);

    return (
        <BulkDeleteButton
            {...props}
            selectedIds={selectedUids}
        />
    );
};

const PostPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100, 250, 500, 1000]} {...props} />;

class DefectiveBracelets extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            count: null
        };
    }

    async componentDidMount() {
        let defective_wristbands = await request('/wristbands/defective/count', 'GET', null);
        this.setState({defective_wristbands: defective_wristbands?.count});
    }

    render() {
        if (this.state.defective_wristbands) {
            return (
                <h3>{translate('custom.defective_bracelet')} - {this.state.defective_wristbands}</h3>
            )
        }
        return (<span></span>)
    }
}

class BalanceTransferFromWristband extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            balance_transfer_from_wristband: null
        };
    }

    async componentDidMount() {
        let balance_transfer_from_wristband = await getBalanceTransferFromWristband();
        this.setState({balance_transfer_from_wristband: balance_transfer_from_wristband?.balance_transfer_from_wristband});
    }

    render() {
        if (this.state.balance_transfer_from_wristband) {
            return (
                <h3>{translate('custom.balance_transfer_from_wristband')} - {this.state.balance_transfer_from_wristband.toFixed(2)}</h3>
            )
        }
        return (<span></span>)
    }
}

const EventNameLabel = ({ eventId }) => {
    const [eventName, setEventName] = useState('');

    React.useEffect(() => {
        const fetchEventName = async () => {
            if(!eventId) return;

            const instance = EventCash.getInstance();
            const name = await instance.fetchEventName(eventId);
            setEventName(name);
        };

        if (eventId) {
            fetchEventName();
        }
    }, [eventId]);

    return <span>{eventName}</span>;
}

class ClientsListClass extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            defective_wristbands: null,
            right: getRight()
        };

        this.history = props.history;
        this.refresh = props.refresh;
        this.deleteOne = props.deleteOne;

        this.mobileLine = [
            r => dateToLocalString(r.creation_date)
        ];

        if(this.state.right >= config.permissions.SUPERADMIN.value) {
            this.mobileLine.push(r => <EventNameLabel eventId={r.event_id} />);
        }

        this.eventNameCache = {};
    }

    handleDeleteClient = async (uid) => {
        const response = await deleteClient(uid);
        if(response.error) {
            notifyError(response.error);
            this.props.refresh();
        } else {
            notifySuccess('custom.client_deleted');
        }
    }

    handleShowClient = (record) => {
        const uid = record.uid;
        if(this.state.right >= config.permissions.SUPERADMIN.value) {
            window.location.href = '/client/' + uid;       
        } else {
            this.history.push('/v1/clients/' + uid);
        }
    }

    render() {
        const { isSmall, is_hybrid, has_ticket } = this.props;

        const lockedFilters = { hybrid: is_hybrid, has_ticket: has_ticket };

        return (
            <>
                {(!is_hybrid && !has_ticket) && (
                    <Stack direction="row" spacing={2} style={{ justifyContent: 'space-between', marginTop: 20 }}>
                        <DefectiveBracelets />
                        <BalanceTransferFromWristband />
                    </Stack>
                )}
    
                <List {...this.props}
                    hasCreate={false}
                    sort={{ field: 'id', order: 'DESC' }}
                    actions={<ClientListActions right={this.state.right} isSmall={isSmall} />}
                    filters={isSmall ? null : <ClientListFilter right={this.state.right} has_ticket={has_ticket} is_hybrid={is_hybrid} />}
                    filter={lockedFilters}
                    pagination={<PostPagination />}
                    perPage={50}
                    empty={false}
                    bulkActionButtons={this.state.right >= config.permissions.SUPERADMIN.value ? false : <CustomBulkActionButtons />}
                >
                    <ResponsiveDatagrid
                        mobile={{
                            title: r => r.name ?? r.uid,
                            lines: [
                                ...this.mobileLine
                            ],
                            right: r => `${formatCurrency(r.balance)} ${this.props?.options?.currency_code ?? 'CHF'}`,
                        }}                        
                        onClick={this.handleShowClient}
                        swipeAction={{
                            icon: <Delete color="error" />,
                            onClick: (record) => this.handleDeleteClient(record.uid),
                            label: translate('custom.delete'),
                            animation: SWIPE_ANIMATIONS.remove,
                            confirmation: {confirm: true, message: translate('custom.confirm_delete_client')}
                        }}
                    >
                        {(this.state.right >= config.permissions.SUPERADMIN.value) ? (
                            <ReferenceField label={translate('custom.event')} source="event_id" reference="events" sortable={false} >
                                <TextField source="name" />
                            </ReferenceField>
                        ) : null}

                        {(has_ticket || !is_hybrid) && <TextField label="UID" source="uid" />}
                        <TextField label={translate('custom.short_id')} source="short_id" />
                        
                        <FunctionField 
                            label={translate('custom.creation_date')}
                            sortBy="_id"
                            render={record => {
                                const timestamp = parseInt(record._id.substring(0, 8), 16) * 1000;
                                return (
                                    <DateField
                                        record={{ ...record, creation_date: new Date(timestamp) }}
                                        source="creation_date"
                                        locales={translate('custom.OPTIONS.i18n_date_format')}
                                        showTime
                                    />
                                );
                            }}
                        />

                        <NumberField label={translate('custom.balance')} source="balance" locales={translate('custom.OPTIONS.i18n_number_format')} options={{ style: 'decimal', minimumFractionDigits: 2 }} />
                        
                        {(!has_ticket && is_hybrid) && <NumberField label={translate('custom.total_spent')} source="total_spent" locales={translate('custom.OPTIONS.i18n_number_format')} options={{ style: 'decimal', minimumFractionDigits: 2 }} />}
                        
                        {(has_ticket || !is_hybrid) && <TextField label={translate('custom.name')} source="name" />}

                        {has_ticket && <TextField label={translate('custom.ticket_id')} source="ticket_id" />}
                        
                        {(!is_hybrid && !has_ticket) && (this.state.right <= config.permissions.ADMIN.value) && <TextField label={translate('custom.import_id')} source="import_id" />}

                        {!has_ticket && <ArrayField label={translate('custom.payment_types')} source="payment_types" sortable={false}>
                            <SingleFieldList linkType={false}>
                                <FunctionField render={item => <Chip size="small" label={translate(`custom.${item}`)} />} />
                            </SingleFieldList>
                        </ArrayField>}
                        
                        {!has_ticket && <ArrayField label={translate('custom.refund_types')} source="refund_types" sortable={false}>
                            <SingleFieldList linkType={false}>
                                <FunctionField render={item => <Chip size="small" label={translate(`custom.refund_types_description.${item}`)} />} />
                            </SingleFieldList>
                        </ArrayField>}

                        {(this.state.right <= config.permissions.ADMIN.value) ? (
                            <FunctionField
                                render={(record) => {
                                    const currentRoute = window.location.hash.replace('#', '').split('?')[0];
                                    return <EditButton to={`${currentRoute}/${record.uid}`} />;
                                }}
                            />
                        ) : (
                            <CustomShowButton />
                        )}
                    </ResponsiveDatagrid>
                </List>
            </>
        );
    }
};

export const ClientList = (props) => {
    const refresh = useRefresh();
    const [deleteOne] = useDelete();
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));

    return <ClientsListClass refresh={refresh} deleteOne={deleteOne} isSmall={isSmall} is_hybrid={false} has_ticket={false} {...props} />;
}

export const ClientListPayment = (props) => {
    const refresh = useRefresh();
    const [deleteOne] = useDelete();
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));

    return <ClientsListClass refresh={refresh} deleteOne={deleteOne} isSmall={isSmall} is_hybrid={true} has_ticket={false} {...props} />;
}

export const ClientListTicket= (props) => {
    const refresh = useRefresh();
    const [deleteOne] = useDelete();
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));

    return <ClientsListClass refresh={refresh} deleteOne={deleteOne} isSmall={isSmall} has_ticket={true} {...props} />;
}
